
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { DomainRegistrantInfoModel } from './Distribution.Api.Models.DomainRegistrantInfo';
import { Model, ModelProperty } from 'models/Model';


export class DomainMoveRequestModel extends Model<DomainMoveRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'domainId', type: 'string' },
		{ name: 'moveFromVatNumber', type: 'string' },
		{ name: 'moveToCompanyId', type: 'string' },
		{ name: 'moveToRegistrantInfo', type: 'DomainRegistrantInfoModel', isHidden: true, isObject: true, new: () => { return new DomainRegistrantInfoModel }, properties: () => { return DomainRegistrantInfoModel.classProperties } }
	];
	[key: string]: any;
	
	public domainId?: string;
	public moveFromVatNumber?: string;
	public moveToCompanyId?: string;
	public moveToRegistrantInfo?: DomainRegistrantInfoModel;
    
	constructor(){
		super();
		this.domainId = undefined;
		this.moveFromVatNumber = undefined;
		this.moveToCompanyId = undefined;
		this.moveToRegistrantInfo = undefined;
		
	}
	getProperties(){
		return DomainMoveRequestModel.classProperties;
	}
}

